export default __webpack_public_path__ + "static/media/header-home-icon.95417c00.svg";